<template lang="pug">
  a(:href="url" target="_blank" title="Google Mapで開く")
    | {{address}}
    |
    |
    i.fa.fa-external-link
</template>

<script>
import MEISHIBANK2 from 'static/config'

export default {
  name: 'AddressLink',
  props: {
    addresses: {type: Array, required: true}
  },
  computed: {
    address () {
      return this.addresses.join(' ')
    },
    url () {
      if (!MEISHIBANK2.googlemap) {
        return '#'
      }

      return encodeURI(MEISHIBANK2.googlemap.baseUrl + this.address)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/molecules/AddressLink.vue